import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  avatar: "",
  userName: "",
  email: "",
  authority: [],
  domain: "admin",
};

export const userSlice = createSlice({
  name: "auth/user",
  initialState,
  reducers: {
    setUser: (_, action) => action.payload,
    userLoggedOut: () => initialState,
    setDomain: (state, { payload }) => {state.domain = payload},
  },
});

export const { setUser, setAppData, setDomain } = userSlice.actions;

export default userSlice.reducer;
